const ALLOWED_AVATAR_DOMAINS = [
  "cdn.example.com",
  "images.gluviacare.com",
  "storage.googleapis.com",
  "s3.amazonaws.com",
];

export const isValidPath = (path: string): boolean => {
  if (!path || typeof path !== "string" || path.length > 256) return false;
  if (path.includes("..") || path.includes("//") || path.includes("\0")) return false;
  return /^\/[a-zA-Z0-9\-_/]*(\?[a-zA-Z0-9\-_=&]*)?(\#[a-zA-Z0-9\-_]*)?$/.test(path);
};

export const sanitizeInput = (input: string | undefined, maxLength: number = 100): string => {
  if (!input || typeof input !== "string") return "User";
  let sanitized = input.trim().replace(/<[^>]*>/g, "").replace(/[<>\"'%;()&+]/g, "");
  return sanitized.replace(/\s+/g, " ").substring(0, maxLength) || "User";
};

export const validateEmail = (email: string | undefined): string => {
  if (!email || typeof email !== "string" || email.length > 254) return "user@example.com";
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email) || email.includes("//") || email.includes("<")) {
    return "user@example.com";
  }
  return email;
};

export const validateAvatarUrl = (avatar: string | undefined): string | null => {
  if (!avatar || typeof avatar !== "string" || avatar.length > 2048) return null;

  try {
    if (avatar.startsWith("/")) {
      if (avatar.includes("..") || avatar.includes("//")) return null;
      return avatar;
    }

    const url = new URL(avatar);
    if (url.protocol !== "https:") return null;

    const isWhitelisted = ALLOWED_AVATAR_DOMAINS.some(
      (domain) => url.hostname === domain || url.hostname.endsWith("." + domain)
    );
    if (!isWhitelisted) return null;

    const pathname = url.pathname.toLowerCase();
    const validExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp"];
    if (!validExtensions.some((ext) => pathname.endsWith(ext))) return null;

    return avatar;
  } catch {
    return null;
  }
};

export const isValidUUID = (id: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id) && id.length === 36;
};

export const generateInitials = (name: string): string => {
  if (!name || typeof name !== "string") return "U";
  return name
    .split(" ")
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0).toUpperCase())
    .slice(0, 2)
    .join("");
};

export const getCsrfToken = (): string | null => {
  try {
    const metaTag = document.querySelector('meta[name="csrf-token"]');
    if (metaTag) {
      const token = metaTag.getAttribute("content");
      if (token && token.length > 20 && token.length < 500) return token;
    }

    const token = sessionStorage.getItem("csrf-token");
    if (token && token.length > 20 && token.length < 500) return token;
    return null;
  } catch {
    return null;
  }
};